import { TextField, Typography } from '@mui/material';
import { ReportingContainer, StyledForm } from './Reporting.styles';
import { getWeekStartDay } from '../../../utils/helpers/venues/venuesHelpers';

const Reporting = ({ startOfWeekIndex }) => {
  const commonTextFieldProps = {
    fullWidth: true,
    variant: 'filled',
    disabled: true,
    InputProps: {
      readOnly: true,
      disableUnderline: true,
    },
  };

  return (
    <ReportingContainer>
      <>
        <Typography variant="h6">Reporting</Typography>
        <Typography variant="subtitle2">
          <em>All fields are populated from your POS system.</em>
        </Typography>
      </>
      <StyledForm>
        <TextField label="Work week starts on" value={getWeekStartDay(startOfWeekIndex)} {...commonTextFieldProps} />
        <TextField
          label="End of day"
          value="4:00 AM" // TODO: Get this data from venue.end_of_day once it's implemented
          {...commonTextFieldProps}
        />
      </StyledForm>
    </ReportingContainer>
  );
};

export default Reporting;
